import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import SiteFooter from '../components/SiteFooter';
import { useWishlist } from '../context/WishlistContext';
import { useLanguage } from '../context/LanguageContext';
import './ShopList.css';

const Wishlist = () => {
  const { items, removeFromWishlist } = useWishlist();
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="home-page">
      <Header />
      <div className="shoplist-page">
        <h1 className="shoplist-title">{t('shoplist.wishTitle')}</h1>

        {items.length === 0 ? (
          <div className="shoplist-empty">
            <p>{t('shoplist.wishEmpty')}</p>
            <Link to="/photobooks" className="shoplist-empty-btn">{t('shoplist.viewProducts')}</Link>
          </div>
        ) : (
          <div className="shoplist-items">
            {items.map((item) => (
              <div key={item.id} className="shoplist-item">
                <div className="shoplist-item-image">
                  {item.image && <img src={item.image} alt={item.name} />}
                </div>
                <div className="shoplist-item-info">
                  <p className="shoplist-item-name">{item.name}</p>
                  <p className="shoplist-item-price">€{item.price?.toFixed(2)}</p>
                </div>
                <div className="shoplist-item-actions">
                  <button className="shoplist-continue-btn" onClick={() => navigate(`/product/${item.id}`)}>
                    {t('card.view')}
                  </button>
                  <button className="shoplist-remove-btn" onClick={() => removeFromWishlist(item.id)}>
                    {t('shoplist.remove')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <SiteFooter />
    </div>
  );
};

export default Wishlist;
